import ParchmentCard from '@/components/ui/ParchmentCard';
import Button from '@/components/ui/Button';
import { resolveAssetUrl } from '@/utils/assets';
import useAuthStore from '@/store/authStore';

const formatDiscount = (offer) => {
  if (offer.discountType === 'free_item') return 'Oferta';
  if (offer.discountType === 'fixed') return `-${Number(offer.discountValue || 0).toFixed(0)}€`;
  return `-${offer.discountPercent || 0}%`;
};

export default function OfferCard({ offer, onRedeem, disabled }) {
  const coins = useAuthStore((s) => s.player?.coins ?? 0);
  const isExpired = offer.expiresAt && new Date(offer.expiresAt) < new Date();
  const outOfStock = offer.stock === 0;
  const notEnoughCoins = coins < (offer.coinCost || 0);
  const unavailable = disabled || isExpired || outOfStock || notEnoughCoins;
  const available = !unavailable;

  return (
    <ParchmentCard
      className="relative overflow-hidden p-0 text-fg"
      style={available ? {
        boxShadow: '0 0 0 1.5px rgba(45,122,45,0.55), 0 4px 20px rgb(var(--hc-bg) / 0.25)',
      } : undefined}
    >
      <div className="relative h-28 bg-surfaceAlt">
        {offer.imageUrl ? (
          <img src={resolveAssetUrl(offer.imageUrl)} alt={offer.title} className="h-full w-full object-cover" />
        ) : (
          <div className="flex h-full w-full items-center justify-center bg-gradient-to-br from-accent/25 via-surface to-forest/15">
            <span className="rounded-full border-2 border-accent/50 bg-surface/60 px-4 py-2 font-urban text-3xl font-black text-accent">
              H
            </span>
          </div>
        )}
        <div className="absolute left-2 top-2 rounded-full border border-white/60 bg-forest px-2.5 py-1 font-urban text-xs font-black text-white shadow-[0_0_8px_rgba(45,122,45,0.6)]">
          {formatDiscount(offer)}
        </div>
        {offer.partner?.name && (
          <div className="absolute bottom-2 left-2 max-w-[82%] truncate rounded-full bg-accent px-3 py-1 text-[11px] font-black uppercase tracking-wide text-white shadow-[0_2px_8px_rgba(0,0,0,0.4)]">
            {offer.partner.name}
          </div>
        )}
      </div>

      <div className="p-3">
        <h3 className="font-urban text-base font-black leading-tight text-fg">{offer.title}</h3>
        <p className="mt-1 line-clamp-2 text-xs font-semibold text-muted">{offer.description || 'Oferta disponível para resgate.'}</p>

        <div className="mt-3 flex items-center justify-between gap-2">
          <div>
            <span className="block font-urban text-lg font-black leading-none text-accent">{offer.coinCost}</span>
            <span className="text-[10px] font-black uppercase tracking-wide text-muted">moedas</span>
          </div>
          <Button
            variant="green"
            className="rounded-lg px-3 py-2 text-xs"
            onClick={() => onRedeem(offer)}
            disabled={unavailable}
          >
            {outOfStock ? 'Esgotado' : isExpired ? 'Expirado' : notEnoughCoins ? 'Sem moedas' : 'Resgatar'}
          </Button>
        </div>
      </div>
    </ParchmentCard>
  );
}
